import React from 'react';
import styled from 'styled-components';
import Logo from './Logo';
import { Flex } from './shared/Flex';
import { colors, fontSize, fontWeight } from '../style/tokens';
import { headerBg, headerFg, headerHoverBg } from '../style/header';

const TopBarWrapper = styled(Flex)`
  width: 100%;
  min-height: 82px;
  justify-content: space-between;
  align-items: center;
  background: ${headerBg};
  border-bottom: 1px solid #f0f0f0;
  padding: 10px 20px 26px;
  flex-shrink: 0;
  position: relative;
`;

const LogoCenter = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
`;

const BackButton = styled.button`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 1.5px solid ${colors.border};
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.15s;
  @media (hover: hover) { &:hover { background: ${headerHoverBg}; } }
  &::before {
    content: '';
    display: block;
    width: 9px;
    height: 9px;
    border-top: 2px solid ${headerFg};
    border-left: 2px solid ${headerFg};
    transform: rotate(-45deg) translate(2px, 0);
  }
`;

const ScanLabel = styled.div`
  font-size: ${fontSize.sm};
  font-weight: ${fontWeight.bold};
  color: ${colors.greenDark};
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 5px 12px;
  background: #f0f9e6;
  border-radius: 20px;
  border: 1px solid #c8e89a;
`;

interface TopBarProps {
  onBack?: () => void;
  isMeasuring?: boolean;
}

const TopBar: React.FC<TopBarProps> = ({ onBack }) => {
  return (
    <TopBarWrapper>
      {onBack
        ? <BackButton onClick={onBack} aria-label="Back" />
        : <span style={{ width: 42 }} />}
      <LogoCenter><Logo /></LogoCenter>
      <span style={{ width: 42 }} />
    </TopBarWrapper>
  );
};

export default TopBar;
